import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import classNames from "classnames";
import { Grid, FormControl,OutlinedInput, Input, GridList} from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import LightButton from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import clsx from 'clsx';
const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const checkIcon = portalCfg.publicPath + "/icons/check.png";
const fb_icon = portalCfg.publicPath + "/icons/facebook_icon.png";
const go_icon = portalCfg.publicPath + "/icons/google_icon.png";

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(40),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop2x: {
        marginTop: theme.spacing(4),
    },
    marginTop4x: {
        marginTop: theme.spacing(8),
    },
    formLogin:{
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding:theme.spacing(5,15,15,15),
    },

});
function ReceiveMarketingView(props){
    const { classes, t } = props;
    return (
         <PublicPage leftComponent={<ReceiveMarketingViewComponent 
            classes={classes} t={t} 
            onReceiveMarketing={props.onReceiveMarketing} onCancelReceiveMarketing={props.onCancelReceiveMarketing} />} />
    );
}

function ReceiveMarketingViewComponent(props) {
    const { classes, t } = props;
    return (
        <Grid xs={12} item justify='center' container className={classes.container}>
                <Grid xs={11} sm={9} md={11} lg={10} xl={8} className={classes.formLogin}>
                    <Grid xs={12} item container justify='center'>
                            <Typo variant='h2' color='onPrimary' >{t('allow_notifications')}</Typo>
                    </Grid>
                    <Grid xs={12} item container className={classes.marginTop4x} justify='center'>
                            <Typo color='onPrimary'  variant='body2' center>{t('marketing_information_request')}{t('landing_loyalty')}{t('marketing_information_request2')}</Typo>
                    </Grid>
                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                        <LightButton color='onPrimary' fullWidth onClick={props.onReceiveMarketing} >{t('marketing_information_sure')}</LightButton>
                    </Grid>
                    <Grid xs={12} item container justify='center' className={classes.marginTop2x}>
                        <LightButton color='transparent' fullWidth onClick={props.onCancelReceiveMarketing} >{t('marketing_information_no')}</LightButton>
                    </Grid>
                </Grid>
        </Grid>

    )
}
export default withStyles(styles)(withTranslation()(ReceiveMarketingView));